<div class="o-grid">
  <div class="o-grid__cell">
    <div class="u-wrapper" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}" >
      <div class="c-card u-osb-md">
        <div class="c-content c-content--lg">
          <div class="o-grid o-grid--center-v">
            <div class="o-grid__cell">
              <section>
                <div class="o-grid">
                  <div class="o-grid__cell c-cell">
                    <form #mainForm="ngForm" style="position: relative">
                      <p class="c-text c-text--bold u-ost-md u-osb-md">{{ 'Modal.Content.Consents_Title_Xroad' | translate }}:</p>
                      <div class="c-form__group u-osb-sm" *ngIf="vm.consents" [ngClass]="{'c-form__group--error': (vm.submitted || xroadHealthInsuranceAccessGrantedInput.dirty) && xroadHealthInsuranceAccessGrantedInput.invalid }">
                        <label class="c-checkbox">
                          <input type="checkbox" id="xroadHealthInsuranceAccessGrantedInput" name="xroadHealthInsuranceAccessGrantedInput" #xroadHealthInsuranceAccessGrantedInput="ngModel" [(ngModel)]="vm.consents.xroadHealthInsuranceAccessGranted" required>
                          <span id="xroadHealthInsuranceAccessGrantedLabel">{{ 'Modal.Content.X_Road_Insurance_Access_Consent' | translate }}</span>
                        </label>
                      </div>
                      <div class="c-form__group u-osb-sm" *ngIf="vm.consents" [ngClass]="{'c-form__group--error': (vm.submitted || xroadPrescriptionsAccessGrantedInput.dirty) && xroadPrescriptionsAccessGrantedInput.invalid }">
                        <label class="c-checkbox">
                          <input type="checkbox" id="xroadPrescriptionsAccessGrantedInput" name="xroadPrescriptionsAccessGrantedInput" #xroadPrescriptionsAccessGrantedInput="ngModel" [(ngModel)]="vm.consents.xroadPrescriptionsAccessGranted" required>
                          <span id="xroadPrescriptionsAccessGrantedLabel">{{ 'Modal.Content.X_Road_Prescriptions_Access_Consent' | translate }}</span>
                        </label>
                      </div>
                      <div class="o-grid">
                        <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
                          <button id="xroadConsentsSubmitButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.updateConsents(mainForm)" [disabled]="vm.loading || vm.btnDisabled">{{ 'Modal.Button.Update' | translate }}</button>
                        </div>
                      </div>
                      <loader-overlay *ngIf="vm.loading" [theme]="3"></loader-overlay>
                    </form>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
